import React, { createContext, useState, useContext, useEffect } from "react";
import {
  auth,
  signOut as firebaseSignOut,
  // --- ADD THESE ---
  signInWithPopup,
  googleProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  // --- END ADD ---
} from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  // --- ADD NEW AUTH FUNCTIONS ---
  const loginWithEmail = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const signupWithEmail = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const signUpWithGoogle = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      // onAuthStateChanged will handle the rest and redirect
    } catch (error) {
      console.error("Google Sign In Error:", error);
      alert(error.message);
    }
  };

  const logout = async () => {
    await firebaseSignOut(auth);
    navigate("/login");
  };
  // --- END OF NEW FUNCTIONS ---

  const value = {
    user,
    logout,
    loginWithEmail, // <-- Add to value
    signupWithEmail, // <-- Add to value
    signUpWithGoogle, // <-- Add to value
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
